import React from 'react';
import {
  HeadingBlock,
  ParagraphBlock,
  ListBlock,
  ImageBlock,
  ButtonBlock,
} from './ContentBlocks';

const ContentItem = ({ content, sectionId, columnId, onUpdate, onRemove, onMove, isFirst, isLast }) => {
  const renderContent = () => {
    const props = {
      data: content.data,
      onChange: (newData) => onUpdate(sectionId, columnId, content.id, newData),
    };

    switch (content.type) {
      case 'heading':
        return <HeadingBlock {...props} />;
      case 'paragraph':
        return <ParagraphBlock {...props} />;
      case 'list':
        return <ListBlock {...props} />;
      case 'image':
        return <ImageBlock {...props} />;
      case 'button':
        return <ButtonBlock {...props} />;
      default:
        return null;
    }
  };

  const getContentTypeLabel = (type) => {
    const labels = {
      heading: 'Heading',
      paragraph: 'Paragraph',
      list: 'List',
      image: 'Image',
      button: 'Button',
    };
    return labels[type] || type;
  };

  const getContentTypeIcon = (type) => {
    const icons = {
      heading: 'bi-type-h1',
      paragraph: 'bi-paragraph',
      list: 'bi-list-ul',
      image: 'bi-image',
      button: 'bi-square',
    };
    return icons[type] || 'bi-file-text';
  };

  return (
    <div className="card mb-3">
      <div className="card-header d-flex justify-content-between align-items-center py-2" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="d-flex align-items-center">
          <i className={`bi ${getContentTypeIcon(content.type)} me-2`} style={{ fontSize: '1.2rem' }}></i>
          <span className="fw-medium">{getContentTypeLabel(content.type)}</span>
        </div>
        <div className="btn-group btn-group-sm">
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={() => onMove(sectionId, columnId, content.id, 'up')}
            disabled={isFirst}
            title="Move up"
            type="button"
          >
            <i className="bi bi-arrow-up"></i>
          </button>
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={() => onMove(sectionId, columnId, content.id, 'down')}
            disabled={isLast}
            title="Move down"
            type="button"
          >
            <i className="bi bi-arrow-down"></i>
          </button>
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => onRemove(sectionId, columnId, content.id)}
            title="Remove"
            type="button"
          >
            <i className="bi bi-trash"></i>
          </button>
        </div>
      </div>
      <div className="card-body">
        {renderContent()}
      </div>
    </div>
  );
};

export default ContentItem;
